// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__b6bea9d5937679beb65c","cls2":"ImpactHubModal-cls2___63eba0b1c781c1fc067 ImpactHubModal-cls1__b6bea9d5937679beb65c"};